import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Notebook, Shield, Home, BookMarked } from 'lucide-react';
export function ValueStackSection() {
  const items = [{
    icon: <BookOpen className="w-6 h-6 text-gold" data-id="element-170" />,
    title: 'Ebook Principal: El Protocolo de la Mañana (60 pág.)',
    desc: 'El mapa exacto de 14 días.',
    value: '$197'
  }, {
    icon: <Notebook className="w-6 h-6 text-gold" data-id="element-171" />,
    title: 'Bonus 1: El Diario de Oración "Conexión Eterna"',
    desc: 'Plantillas para ver milagros.',
    value: '$47',
    tag: 'GRATIS HOY'
  }, {
    icon: <Shield className="w-6 h-6 text-gold" data-id="element-172" />,
    title: 'Bonus 2: Guía: Los 7 Salmos de Poder',
    desc: 'Tu manual de protección real.',
    value: '$67',
    tag: 'GRATIS HOY'
  }, {
    icon: <Home className="w-6 h-6 text-gold" data-id="element-173" />,
    title: 'Bonus 3: Checklist: Hogar en Paz',
    desc: 'Cómo limpiar la atmósfera de tu casa.',
    value: '$37',
    tag: 'GRATIS HOY'
  }, {
    icon: <BookMarked className="w-6 h-6 text-gold" data-id="element-174" />,
    title: 'Bonus 4: Guía: Lectura Bíblica Rápida',
    desc: 'Entiende la Biblia en 10 min.',
    value: '$97',
    tag: 'GRATIS HOY'
  }];
  return <section className="py-10 md:py-24 px-4 bg-white" data-id="element-175">
      <div className="max-w-6xl mx-auto" data-id="element-176">
        <div className="text-center mb-8 md:mb-16" data-id="element-177">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-teal-dark mb-4" data-id="element-178">
            Hoy tienes la oportunidad de obtener el sistema completo de{' '}
            <span className="text-gold" data-id="element-179">"Blindaje Espiritual"</span>:
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-12 items-center" data-id="element-180">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-181">
            <img src="https://cdn.magicpatterns.com/uploads/ph3TqvShZoWL1GB8WikDyW/hf_20260319_213435_88d14265-cbf1-4ff8-960c-f0f0c4ea3116.jpg" alt="Colección completa de El Protocolo de la Mañana y Bonus" className="w-full h-auto rounded-xl shadow-2xl" data-id="element-182" />
          </motion.div>

          <div className="space-y-4" data-id="element-183">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className={`flex items-start gap-4 p-4 rounded-lg ${index === 0 ? 'bg-cream border border-gold/30' : 'bg-gray-50'}`} data-id="element-184">
                <div className="mt-1 bg-white p-2 rounded-full shadow-sm" data-id="element-185">
                  {item.icon}
                </div>
                <div className="flex-1" data-id="element-186">
                  <h3 className="font-bold text-lg text-teal-dark" data-id="element-187">
                    {item.title}
                  </h3>
                  <p className="text-charcoal/70" data-id="element-188">{item.desc}</p>
                </div>
                <div className="text-right flex flex-col items-end gap-1" data-id="element-189">
                  <span className="text-sm text-gray-400 line-through block" data-id="element-190">
                    Valor:
                  </span>
                  <span className="font-bold text-gray-400 line-through" data-id="element-191">
                    {item.value}
                  </span>
                  {(item as any).tag && <span className="text-xs font-bold bg-red-600 text-white px-2 py-0.5 rounded-full animate-pulse" data-id="element-192">
                      {(item as any).tag}
                    </span>}
                </div>
              </motion.div>)}

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.6
          }} className="mt-8 p-6 bg-teal-dark text-white rounded-xl text-center shadow-lg" data-id="element-193">
              <p className="text-lg mb-1" data-id="element-194">VALOR TOTAL:</p>
              <p className="text-4xl font-bold font-heading text-gold-light line-through decoration-red-500 decoration-4" data-id="element-195">
                $445+
              </p>
              <div className="mt-3 pt-3 border-t border-white/20" data-id="element-196">
                <p className="text-sm text-white/70 uppercase tracking-wide" data-id="element-197">
                  Hoy todo por solo
                </p>
                <p className="text-5xl font-bold font-heading text-gold mt-1" data-id="element-198">
                  $13.99{' '}
                  <span className="text-lg font-normal text-white/60" data-id="element-199">USD</span>
                </p>
                <p className="text-sm text-green-300 font-bold mt-1" data-id="element-200">
                  Ahorras más de $431 USD
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}